import React, {useCallback} from 'react';
import PropTypes from 'prop-types'
import {useDispatch} from "react-redux";
import {elementSectionChanged} from "../../store/product/productElementsSlice";
import debounce from 'lodash/debounce'

const SectionNumberField = (props) => {
    const dispatch = useDispatch();
    const onChange = (value) => {
        dispatch(elementSectionChanged(props.elementKey, value))
    }

    const debouncedHandler = useCallback(
        debounce(onChange, 300)
    ,[]);
    const style = {
        container: {
            display: 'flex',
            alignItems: 'center',
        },
        label: {
            marginRight: '5px',
        },
        input: {
            marginBottom: 0,
            width: '100px',
        }
    }

    return (
        <div style={style.container}>
            <label style={style.label}>Section #: </label>
            <input style={style.input} type={'number'}  defaultValue={props.element.section_number} onChange={(e) => debouncedHandler(e.target.value)}/>
        </div>
    )
}

SectionNumberField.proptypes = {
    element: PropTypes.object.isRequired,
    elementKey: PropTypes.number.isRequired
}

export default SectionNumberField